/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletGroupIcon20Light = forwardRef('TextBulletGroupIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4Zm4 0H3v3h3V4Z" }),
        React.createElement("path", { d: "M9.5 3a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z" }),
        React.createElement("path", { d: "M9 7.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M9.5 11a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z" }),
        React.createElement("path", { d: "M9.5 15a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 11a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H3Zm0 1h3v3H3v-3Z" })));
});
